/**
 * Run a callback on DOM ready and custom 'page-change' event,
 * passing a flag to indicate the trigger source.
 *
 * @param {Function} callback - The function to call (receives trigger source)
 */
export const initComponent = (callback, ignorePageChange = false, sprigReinitialise = false) => {
	// Helper to run the callback with a pageChange flag, useful for components that
	// need to know if they are being initialized on page load or a page change.
	//
	const run = (pageChange) => {
		callback(pageChange)
	}

	// If page is already loaded, fire immediately
	//
	if (document.readyState === 'complete') {
		run()
	}

	// Otherwise wait for it to load
	//
	window.addEventListener('load', () => {
		run()
	})

	// Listen for barba page change event
	//
	if (ignorePageChange === false) {
		window.addEventListener('page-change', () => {
			run(true)
		})
	}

	// Listen for htmx page change event
	//
	if (sprigReinitialise === true && typeof htmx !== 'undefined') {
		htmx.on('htmx:afterSwap', function (event) {
			setTimeout(() => {
				run()
			}, 250)
		})
	}
}

globalThis.initComponent = initComponent
